// @ts-ignore
var PointType = 'pickup' | 'dropoff' | 'experience' | 'parking' | 'waypoint';
export var POINT_TYPE_LABELS_BY_LANG = {
    en: {
        pickup: 'Pickup point',
        dropoff: 'Dropoff point',
        experience: 'Experience location',
        parking: 'Parking',
        waypoint: 'Waypoint',
        dropon: 'Check-in point',
        sales: 'Sales point',
        office: 'Office',
    },
    es: {
        pickup: 'Punto de recogida',
        dropoff: 'Punto de bajada',
        experience: 'Lugar de la experiencia',
        parking: 'Aparcamiento',
        waypoint: 'Punto intermedio',
        dropon: 'Punto de entrada',
        sales: 'Punto de venta',
        office: 'Oficina',
    },
    fr: {
        pickup: 'Point de ramassage',
        dropoff: 'Point de dépose',
        experience: 'Lieu de l’expérience',
        parking: 'Parking',
        waypoint: 'Point intermédiaire',
        dropon: 'Point d’entrée',
        sales: 'Point de vente',
        office: 'Bureau',
    },
    it: {
        pickup: 'Punto di raccolta',
        dropoff: 'Punto di discesa',
        experience: 'Luogo dell’esperienza',
        parking: 'Parcheggio',
        waypoint: 'Punto intermedio',
        dropon: 'Punto di ingresso',
        sales: 'Punto vendita',
        office: 'Ufficio',
    },
    pt: {
        pickup: 'Ponto de recolha',
        dropoff: 'Ponto de desembarque',
        experience: 'Local da experiência',
        parking: 'Estacionamento',
        waypoint: 'Ponto intermediário',
        dropon: 'Ponto de entrada',
        sales: 'Ponto de venda',
        office: 'Escritório',
    },
    nl: {
        pickup: 'Ophaalpunt',
        dropoff: 'Afladingspunt',
        experience: 'Ervaringslocatie',
        parking: 'Parkeerplaats',
        waypoint: 'Tussenpunt',
        dropon: 'Ingangspunt',
        sales: 'Verkooppunt',
        office: 'Kantoor',
    },
    de: {
        pickup: 'Abholpunkt',
        dropoff: 'Abgabepunkt',
        experience: 'Erfahrungsort',
        parking: 'Parkplatz',
        waypoint: 'Zwischenpunkt',
        dropon: 'Eingangspunkt',
        sales: 'Verkaufspunkt',
        office: 'Büro',
    },
    ar: {
        pickup: 'نقطة الاستلام',
        dropoff: 'نقطة النزول',
        experience: 'موقع التجربة',
        parking: 'موقف السيارات',
        waypoint: 'نقطة وسيطة',
        dropon: 'نقطة الدخول',
        sales: 'نقطة البيع',
        office: 'مكتب',
    },
};



//////////////////
// WEBPACK FOOTER
// ./src/components/LocationPicker/PointType.ts
// module id = 1540
// module chunks = 0